import dayjs, { OpUnitType } from 'dayjs';

export const getBecomeDaysByTargetDate = (targetDate: Date, length: number) => {
  return Array.from({ length }, (_, i) => {
    const day = new Date(targetDate);
    day.setDate(day.getDate() + (i + 1));
    return day;
  });
};

export const getDayBeforeDate = (targetDate: Date) => {
  const yesterday = new Date(targetDate);
  yesterday.setDate(yesterday.getDate() - 1);
  return yesterday;
};

export const formatDateTimeWithDash = (date: Date) => {
  return new Intl.DateTimeFormat('fr-CA', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(date);
};

export const formatDateTimeWithDot = (date: Date | number) => {
  return dayjs(date).format('YYYY.MM.DD');
};

export const formatYearMonthToKr = (date: Date) => {
  return new Intl.DateTimeFormat('ko-kr', {
    year: 'numeric',
    month: 'long',
  }).format(date);
};

export const getNextYearDate = (currentDate: Date) => {
  return new Date(currentDate.getFullYear() + 1, currentDate.getMonth(), currentDate.getDate());
};

export const getDay = (date: Date) => date.getDay();
export const getDate = (date: Date) => date.getDate();

export const getDayOfTheWeek = (day: number) => {
  switch (day) {
    case 0:
      return '일';
    case 1:
      return '월';
    case 2:
      return '화';
    case 3:
      return '수';
    case 4:
      return '목';
    case 5:
      return '금';
    case 6:
      return '토';
  }
};

export const formatMonthWeekDateToKr = (targetDate: string) => {
  const date = new Date(targetDate);
  return new Intl.DateTimeFormat('ko-kr', {
    month: 'long',
    day: '2-digit',
    weekday: 'short',
  }).format(date);
};
export const formatYearMonthWeekDateToKr = (targetDate: Date) => {
  return dayjs(targetDate).format('YYYY.MM.DD');
};

export const formatHour12Time = (targetTime: string) => {
  const [hour, minute] = targetTime.split(':');
  const formattedHour = parseInt(hour, 10);

  if (formattedHour === 0) {
    return `밤 12시 ${minute}분`;
  } else if (formattedHour === 12) {
    return `낮 12시 ${minute}분`;
  } else if (formattedHour > 12) {
    return `오후 ${formattedHour - 12}시 ${minute}분`;
  } else {
    return `오전 ${formattedHour}시 ${minute}분`;
  }
};

export const isBetweenDate = ({
  startAt,
  endAt,
  unitType,
}: {
  startAt: string;
  endAt: string;
  unitType: OpUnitType | null | undefined;
}) => {
  return dayjs().isBetween(startAt, endAt, unitType, '[]');
};

export const isSameDate = (date: Date | string, unitType?: OpUnitType) => {
  return dayjs().isSame(date, unitType);
};

export const sleep = (ms: number) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

export const isAfterTargetDate = (targetDate: string) => {
  return dayjs().isAfter(dayjs(targetDate));
};

export const isBeforeTargetDate = (targetDate: string) => {
  return dayjs().isBefore(dayjs(targetDate));
};
